<script setup lang="ts">
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'

import authV2ForgotPasswordIllustrationDark from '@images/pages/auth-v2-forgot-password-illustration-dark.png'
import authV2ForgotPasswordIllustrationLight from '@images/pages/auth-v2-forgot-password-illustration-light.png'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'
import {VForm} from "vuetify/components/VForm";
import type {UserProperties} from "@/pages/erp/du/user/db/du-user-types";

const email = ref('')
const errors = ref<Record<string, string | undefined>>({
  email: undefined
})

const authThemeImg = useGenerateImageVariant(authV2ForgotPasswordIllustrationLight, authV2ForgotPasswordIllustrationDark)

const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})
const units = ref(['單位 1', '單位 2', '單位 3']);
const positions = ref(['職稱 1', '職稱 2', '職稱 3']);

const form = ref({
  compNo: 'nstc',
  email: '',
  username: '',
  depNo: '',
  postNo: '',
  phone: '',
  password: '',
  chkPassword: '',
  privacyPolicies: false,
})

const resultMsg = ref('')


const fetchUser = () => {
  $api('/du/user/userRegister/register', {
    method: 'GET',
    query: { email: email.value },
  }).then((resp) => {
    console.log(resp)
    const user = resp.data.userRegister
    form.value.email = user.email
    form.value.username = user.username
    form.value.depNo = toCode(user.depNo)
    form.value.postNo = toCode(user.postNo)
    form.value.phone = user.phone

    resultMsg.value = toText(user.approveStatus)
  }).catch(({response}) => {
    console.log(response)
    resultMsg.value = response._data?.message
  })
}



</script>

<template>
  <VContainer class="d-flex justify-center align-center" fluid style="min-height: 100vh;">
    <VRow class="d-flex justify-center">
      <VCol cols="12" md="6" lg="4">
        <VCard class="pa-5">
          <VCardTitle class="text-center"><VNodeRenderer class="text-center" :nodes="themeConfig.app.logo" /></VCardTitle>
          <VCardTitle class="text-center">查詢帳號註冊結果</VCardTitle>
          <VAlert
            class="text-center"
            variant="outlined"
            :color="form.email == '' ? 'error' : 'info'"
            v-if="resultMsg != ''"
          >
            {{ resultMsg }}
          </VAlert>
          <VForm ref="refVForm" >

            <div v-if="form.email == ''">
              <!-- 帳號(Email) -->
              <VRow>
                <VCol cols="12">
                  <AppTextField
                    v-model="email"
                    label="電子信箱"
                    placeholder="請輸入您的電子信箱"
                    outlined
                    dense
                    required
                    :rules="[requiredValidator, emailValidator]"
                    :error-messages="errors.email"
                  />
                </VCol>
              </VRow>


              <!-- 送出按鈕 -->
              <VRow >
                <VCol cols="12">
                  <VBtn :disabled="email == ''" block color="primary" @click="fetchUser">
                    查詢
                  </VBtn>
                </VCol>
              </VRow>
            </div>
            <div v-else>
              <!-- 帳號(Email) -->
              <VRow>
                <VCol cols="12">
                  <AppTextField
                    v-model="form.email"
                    label="電子信箱"
                    outlined
                    dense
                    required
                    :rules="[requiredValidator, emailValidator]"
                    :error-messages="errors.email"
                    disabled
                  />
                </VCol>
              </VRow>

              <!-- 姓名 -->
              <VRow>
                <VCol cols="12">
                  <AppTextField
                    v-model="form.username"
                    label="姓名"
                    outlined
                    dense
                    :rules="[requiredValidator]"
                    disabled
                  />
                </VCol>
              </VRow>

              <!-- 單位與職稱 -->
              <VRow>
                <VCol cols="12" sm="6" class="pr-sm-2">
                  <AppInput
                    v-model="form.depNo"
                    label="單位"
                    type="select"
                    :remoteItem="duDepartmentSelect"
                    item-title="label"
                    item-value="value"
                    disabled
                  />
                </VCol>
                <VCol cols="12" sm="6" class="pl-sm-2">
                  <AppInput
                    v-model="form.postNo"
                    label="職稱"
                    type="select"
                    :remoteItem="duPositionSelect"
                    item-title="label"
                    item-value="value"
                    disabled
                  />
                </VCol>
              </VRow>

              <!-- 電話 -->
              <VRow>
                <VCol cols="12">
                  <AppTextField
                    v-model="form.phone"
                    label="電話"
                    outlined
                    dense
                    disabled
                  />
                </VCol>
              </VRow>
            </div>
            <VRow>
              <VCol cols="12" class="text-center">
                <a href="/login" class="text-decoration-none">返回登入頁面</a>
              </VCol>
            </VRow>
          </VForm>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
